// extracted by mini-css-extract-plugin
export default {"titleFontSize":"ExperimentBreadcrumbs_titleFontSize__wn2Wb"};